import I18n from "i18n-js";
import { makeAutoObservable } from "mobx";
import { toPairs } from "../../core";
import { ErrorBox, SelectableFieldController } from "../../form";
export class PaymentFormController {
    constructor(params) {
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        const initialValue = this.getInitialValue(params.paymentMediums, params.fulfillmentInstructions.paymentMedium);
        this.paymentMediumController = new SelectableFieldController({
            initialValue,
            onUpdate: (value) => {
                params.fulfillmentInstructions.paymentMedium = value.domainValue;
            },
            onClear: () => {
                params.fulfillmentInstructions.paymentMedium = null;
            },
            errorBox: new ErrorBox({
                domainObjects: [params.fulfillmentInstructions],
                errorMessages: {
                    PaymentMediumMissing: I18n.t("orders.checkout.payment_method.required"),
                },
            }),
        });
        makeAutoObservable(this);
    }
    get fields() {
        return {
            paymentMedium: this.paymentMediumController,
        };
    }
    get fieldsArray() {
        return toPairs(this.fields).map(([_, field]) => field);
    }
    get isDirty() {
        return this.fieldsArray.some((field) => field.isDirty);
    }
    get isTouched() {
        return this.fieldsArray.some((field) => field.isTouched);
    }
    get isInvalid() {
        const fieldsInvalid = this.fieldsArray.some((field) => field.isInvalid);
        const modelInvalid = this.fulfillmentInstructions.paymentAvailability.isAvailable
            .isDefinitelyFalse;
        return fieldsInvalid || modelInvalid;
    }
    get isValid() {
        return !this.isInvalid;
    }
    get domain() {
        return this.fulfillmentInstructions;
    }
    submit() {
        this.fieldsArray.forEach((field) => field.blur());
    }
    getInitialValue(paymentMediums, domain) {
        if (paymentMediums === null || domain === null) {
            return null;
        }
        const medium = paymentMediums.findWhere((medium) => medium.isSelected(domain)) || null;
        if (medium === null) {
            return null;
        }
        return medium.kind === "OnlineGroup" ? medium.getChannel(domain) : medium;
    }
}
